<div class="container-fluid">
  <!-- <div class="row justify-content-center">
    <div class="col-12 d-flex justify-content-center pt-3">
      <div class="row d-inline-flex adjust-text-right">
        <div class="col px-0">
          <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
        </div>
        <div class="col d-flex px-0">
          <div class="separator-blue"></div>
        </div>
        <div class="col px-0">
          <img [attr.alt]="vectoralt" [attr.src]="vectorfilled" />
        </div>
        <div class="col d-flex px-0">
          <div class="separator-blue"></div>
        </div>
        <div class="col px-0">
          <img [attr.alt]="vectoralt" [attr.src]="vectorfilled" />
        </div>
        <div class="col d-flex px-0">
          <div class="separator-blue"></div>
        </div>
        <div class="col px-0">
          <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
        </div>
        <div class="col d-flex px-0">
          <div class="separator-white"></div>
        </div>
        <div class="col px-0">
          <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
        </div>
      </div>
    </div>
    <div class="col-12 d-flex justify-content-center pt-2">
      <div class="row d-inline-flex adjust-text-right">
        <div class="col px-0">
          <span class="letter-style-simulate-steps-grey">Cotizar</span>
        </div>
        <div class="col d-flex px-0">
          <div class="separator-letter-transparent"></div>
        </div>
        <div class="col px-0">
          <span class="letter-style-simulate-steps-grey">Customizar</span>
        </div>
        <div class="col d-flex px-0">
          <div class="separator-letter-transparent"></div>
        </div>
        <div class="col px-0">
          <span class="letter-style-simulate-steps-blue">Contacto</span>
        </div>
        <div class="col d-flex px-0">
          <div class="separator-letter-transparent"></div>
        </div>
        <div class="col px-0">
          <span class="letter-style-simulate-steps-grey">Pago</span>
        </div>
        <div class="col d-flex px-0">
          <div class="separator-letter-transparent"></div>
        </div>
        <div class="col px-0">
          <span class="letter-style-simulate-steps-grey">Certificado</span>
        </div>
      </div>
    </div>
  </div> -->
  <div class="form-step">
    <div class="row d-flex">
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt4" [attr.src]="vectorfilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-blue"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div>
      <div class="col d-flex px-0">
        <div class="separator-white"></div>
      </div>
      <div class="col px-0">
        <img [attr.alt]="vectoralt" [attr.src]="vectorUnFilled" />
      </div>
    </div>
    <div class="row d-flex">
      <div class="col px-0">
        <span class="letter-style-simulate-steps-blue">Cotizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-blue">Customizar</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-blue">Contacto</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Pago</span>
      </div>
      <div class="col d-flex px-0">
        <div class="separator-letter-transparent"></div>
      </div>
      <div class="col px-0">
        <span class="letter-style-simulate-steps-grey">Certificado</span>
      </div>
    </div>
  </div>
  <span class="letter-style-normal font-weight-bolder text-center d-block pt-3">Acepta los terminos y condiciones para continuar con el pago.
  </span>
<!-- Button trigger modal -->


<!-- Modal -->
<div class="modal fade aceptar-section" id="exampleModalCenter" tabindex="-1" role="dialog"
  aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <p class="title-modal">Los Términos y Condiciones deben ser leidos y aceptados para poder continuar.</p>
        <div class="aceptar-modal">
          <p class="font-weight-bold">POLITICA DE CANCELACION Y DEVOLUCION</p>
          <p><span class="font-weight-bold">REQUISITOS DE LA INFORMACION:</span> La tramitación de una tarjeta de crédito requiere de la adquisición de la información pertinente,
          incluyendo el número de la tarjeta de crédito, fecha de expiración, nombre y el código CVV2, según
          aparece en la tarjeta de crédito. Información adicional podría incluir; pero no taxativamente la
          dirección de facturación de la tarjeta de crédito, un correo electrónico válido y número de teléfono
          del comprador, y la exención del impuesto de venta, cuandoaplique.</p>
          <p><span class="font-weight-bold">PROTECCION DE PRIVACIDAD:</span> En el momento de la compra y motivos de seguridad, un empleado administrativo de Redbridge podrá
          adquirir por teléfono la información requerida para procesarla tarjeta de crédito. Para su protección,
          la información no podrá ser transmitida ni será aceptada por otros métodos de transmisión como son el
          correo electrónico o facsímil. Redbridge tomara todos los pasos necesarios para proteger la
          información personal de los usuarios. Para el propósito de esta cláusula “información personal” deberá
          definirse como la información adquirida en el momento que se procesa la tarjeta de crédito.</p>
          <p><span class="font-weight-bold">CONFIRMACION DE LA TARJETA DE CREDITO:</span> Toda la información requerida previamente será confirmada por correo electrónico durante el proceso de
          confirmación de la orden, con la excepción del código CVV2, donde se utiliza únicamente los últimos
          cuatro dígitos de la tarjeta de crédito y cualquier otra información pertinente, según provista en el
          momento de adquirir la información por teléfono.
          </p>
          <p><span class="font-weight-bold">ENTREGA DE MERCANCIA Y SERVICIOS:</span> La entrega de servicios que son remunerados con pagos por tarjeta de crédito estará sujeta al recibo
          de confirmación del pago total bajo la única discreción de Redbridge. El periodo de confirmación
          normal fluctúa de 2 a 4 días laborables.</p>
          <p><span class="font-weight-bold">TERMINOS Y LIMITACIONES DE LA TRANSACCCION:</span> Redbridge acepta la responsabilidad en todo aspecto relacionados con la transacción incluyendo la
          venta de los servicios ofrecidos en este sitio-web, servicios al cliente, apoyo, resolución de
          disputas. Al utilizar su tarjeta de crédito para pagar por sus servicios, usted confirma ser el
          titular de la tarjeta utilizada. Todo titular de tarjeta de crédito está sujeto a chequeos de
          validación y autorización por la entidad emisora de la tarjeta y nosotros no estamos obligados a
          informarle la razón de cualquier rechazo. Redbridge no admite responsabilidad alguna de parte de la
          entidad emisora, ni por cargos impuestos en su tarjeta como resultado del procesamiento de su pago, en
          cumplimiento con su instrucción. Además, nosotros no seremos responsables por cualquier pérdida que
          usted pueda incurrir al trasmitir información a Redbridge por enlace (link) de internet o por correo
          electrónico. Redbridge no acepta responsabilidad alguna por pérdidas, parcial o total, y serán de su
          única responsabilidad.</p>
          <p><span class="font-weight-bold">CANCELACION Y DEVOLUCION:</span> Si usted cambia de parecer sobre la compra de nuestros servicios y cancela, al enviarnos un correo
          electrónico a service#&64blueassist.com, con más de 72 horas previas a la fecha de salida
          registrada de su viaje, nosotros le devolveremos el costo menos el 20% del precio total o un mínimo de
          US $20.00, la cantidad que sea mayor, e impuestos, si alguno. La devolución será realizada por el
          mismo método de pago que usted utilizo al comprar nuestros servicios. Nosotros no emitiremos
          devoluciones, cuando la solicitud de cancelación sea recibida por nosotros con 72 horas o meno previas
          a la fecha de salida registrada de su viaje.</p>
          <p class="font-weight-bold">TERMINOS Y CONDICIONES DE UTILIZACION</p>
          <p>
            <span class="font-weight-bold">BLUEASSIST TRAVEL ASSIST</span>
            junto con sus subsidiarias y afiliadas, (“Redbridge”) provee la información y servicios en su Página
            Web Global (“Sitio”) bajo los siguientes términos y condiciones. Al accesar o utilizar este Sitio,
            usted (“Usuario”) acepta todos los términos y condiciones.
          </p>
          <p>
            <span class="font-weight-bold">LEYES Y REGULACIONES:</span>
            El acceso y uso de este Sitio está sujeto a todas leyes y regulaciones aplicables. El Usuario acuerda
            no utilizar este Sitio de forma alguna que viole estas reglas y regulaciones.
          </p>
          <p>
            <span class="font-weight-bold">DERECHOS DE AUTOR Y MARCA REGISTRADA:</span>
            La información disponible en o a través de este Sitio es propiedad de Redbridge, o sus licenciantes, y
            está protegida por las leyes de los Derechos de Autor y Marca Registrada. Los Usuarios no pueden
            modificar, copiar, distribuir, transmitir, publicar, vender, licenciar, crear escritos derivados de, o
            de ninguna otra forma utilizar cualquier información disponible en o a través de este Sitio para uso
            comercial. Los Usuarios no pueden utilizar la marca registrada, logos y marcas de servicios (“Marcas”)
            incluyendo, taxativamente el uso de “enlaces clave” (hot links) o “portales registrados” (meta tags)
            en otras páginas o sitios en la Página Web Global sin el previo consentimiento escrito de Redbridge.
          </p>
          <p>
            <span class="font-weight-bold">INOBSERVANCIAS:</span>
            El Usuario acuerda no modificar, mover, añadir a, eliminar o de otra manera infringir la información
            comprendida en este Sitio. El Usuario también acuerda no descompilar, revertir ingeniería, desarmar, o
            ilegalmente usar o reproducir cualquier programa u otra propiedad material comprendida en este Sitio.
          </p>
          <p>
            <span class="font-weight-bold">ENLACES A OTROS SITIOS:</span>
            Este Sitio puede incluir enlaces a otros sitios-web que no están bajo el control de Redbridge. Esto es
            hecho por conveniencia y Redbride no aprueba ni asume obligación o responsabilidad civil por el
            contenido de estos sitios.
          </p>
          <p>
            <span class="font-weight-bold">ENLACES DE OTROS SITIOS:</span>
            Redbridge prohíbe los enlaces no autorizados a este Sitio y la aplicación de cualquier información
            aquí comprendida. Redbridge se reserve el derecho de deshabilitar cualquier enlace o aplicación no
            autorizada. Redbridge no aprueba ni se responsabiliza por la información comprendida en cualquier otro
            sitio-web que pueda tener enlace con este Sitio.
          </p>
          <p>
            <span class="font-weight-bold">INFORAMACION A TERCERAS PARTES:</span>
            Alguna de la información en este Sitio puede ser facilitada a terceras partes. Mientras que Redbridge
            realiza todo esfuerzo comercialmente razonable para atestar la exactitud de la información en este
            Sitio, esto no garantiza la exactitud y compleción de cualquier información.
          </p>
          <p>
            <span class="font-weight-bold">NO GARANTIAS:</span>
            La información y documentos en este Sitio son provistos sin garantía de algún tipo, tanto expresa o
            implícita, incluyendo, sin limitación, garantías de comercialización, prácticas con particular
            propósito y no-infracción. Redbridge no ofrece garantías ni representaciones de la exactitud y
            compleción de cualquier información en este Sitio. Redbridge, de vez en cuando, podrá añadir, cambiar,
            o eliminar sin previo aviso, información y documentos de este Sitio. Redbridge no acepta obligación ni
            responsabilidad civil por errores y omisiones en este Sitio. Los usuarios acceden y utilizan este
            Sitio, bajo su responsabilidad.
          </p>
          <p>
            <span class="font-weight-bold">LIMITE DE RESPONSABILIDAD:</span>
            Por ninguna circunstancia Redbridge deberá ser responsable por daños sufridos por el Usuario,
            incluyendo cualquier incidental, especifico o daño consecuente, que derive de acceder, utilizar o
            inhabilitar el uso de este Sitio, o por cualquier infracción de seguridad asociada con la transmisión
            de información a través de internet, incluso cuando Redbridge haya sido notificado de la posibilidad
            de dichos daños.
          </p>
          <p>
            <span class="font-weight-bold">PRIVACIDAD:</span>
            Favor de referirse al Aviso de Privacidad de Redbridge, publicado en este Sitio.
          </p>
          <p>
            <span class="font-weight-bold">SEGURIDAD:</span>
            La seguridad de la información transmitida a través de internet no es garantizada. Redbridge no es
            responsable por cualquier intercepción o interrupción de cualquier comunicación a través de internet o
            por cambios o perdida de datos. El Usuario es responsable por la seguridad de cualquier
            identificación, clave de seguridad o cualquier otra forma de autenticidad.
          </p>
          <p>
            <span class="font-weight-bold">TRANSMISION DE DATOS PERSONALES:</span>
            El Usuario reconoce y acepta que al proveer a Redbridge con cualquier información personal a través de
            este Sitio, el Usuario consiente la trasmisión de dicha información a través de confines
            internacionales.
          </p>
          <p>
            <span class="font-weight-bold">ACCESO DE AREAS PROTEGIDAS:</span>
            El acceso y uso de clave de seguridad en áreas protegidas de este Sitio se encuentra restricto a
            usuarios autorizados únicamente. El acceso no-autorizado está prohibido en dichas áreas.
          </p>
            <p class="font-weight-bold">AVISO DE PRIVACIDAD</p>
          <p>
            <span class="font-weight-bold">BLUEASSIST TRAVEL ASSIST</span>
            obedece y realiza todo esfuerzo comercialmente posible para proteger su (Usuario) privacidad. Las
            normas a continuación rigen la información y práctica de privacidad nuestra en esta Página-Web
            (Sitio).
          </p>
          <p>
            <span class="font-weight-bold">USO DE INFORMACION.</span>
            Información confidencial puede ser utilizada para rastrear el número de visitantes a este Sitio. Esta
            información es únicamente para uso interno y no es compartida con terceras partes. Información
            personal identificable como es, nombre, dirección y número de identificación solo se obtiene cuando el
            Usuario la provee voluntariamente y con el único propósito de identificación. Nosotros no divulgaremos
            su información sin su permiso, excepto con el propósito de cumplir con su solicitud de información,
            productos o servicios ofrecidos en este Sitio. Nosotros no negociaremos su información sin su
            consentimiento.
          </p>
          <p>
            <span class="font-weight-bold">REQUISITO LEGAL.</span>
            Nosotros podríamos necesitar revelar su información personal confidencial cuando nos sea requerido por
            ley, como cuando sea necesario cumplir con un mandato gubernamental, procedimientos jurídicos, orden
            de la corte o cualquier otro proceso legal.
          </p>
          <p>
            <span class="font-weight-bold">OTRAS PAGINA-WEB.</span>
            Este Sitio puede tener conexiones a otros sitios-web con avisos y prácticas de privacidad diferentes.
            Nosotros no somos responsables por los avisos o prácticas de privacidad de cualquier otro sitio-web.
          </p>
          <p>
            <span class="font-weight-bold">CONFIDENCIALIDAD.</span>
            Nosotros haremos todo esfuerzo comercialmente posible para proteger la información confidencial de
            nuestros Usuarios contra daños o uso no-autorizado. El acceso a su información confidencial es
            restringido a nuestros empleados, representantes autorizados y otros que necesitan conocer de esta
            información para proveerle a usted con la información, productos y servicios que usted ha solicitado.
            Nosotros salvaguardamos los recursos tangibles, electrónicos y técnicos para proteger información
            confidencial.
          </p>
          <p>
            <span class="font-weight-bold">MODIFICACIONES</span>
            Este Aviso de Privacidad está sujeto a cambios sin previa notificación; pero cualquier cambio será
            colocado en esta página, de nuestro Sitio-web.
          </p>
          <p class="font-weight-bold">CANCELLATION AND RETURN POLICY</p>
          <p>
            <span class="font-weight-bold">INFORMATION REQUIREMENTS:</span>
            The processing of a credit card payment shall require the collection of pertinent information
            including the credit card number, expiration date, name and CVV2 code as it appears on the credit
            card. Additional required information shall include but not be limited to the credit card billing
            address, a valid email address and telephone number of the purchaser, and a valid sales tax exemption
            number when applicable.
          </p>
          <p>
            <span class="font-weight-bold">PRIVACY PROTECTION:</span>
            For security purposes, credit card processing information shall be acquired by telephone at time of
            purchase order by authorized administrative personnel of Redbridge. Information may not be transmitted
            nor will it be accepted by other methods such as email or fax transmissions for your protection.
            Redbridge shall take all reasonable steps to protect the personal information of users. For the
            purpose of this clause, “personal information” shall be defined as all information collected at time
            of credit card payment processing.
          </p>
          <p>
            <span class="font-weight-bold">CREDIT CARD INFORMATION CONFIRMATION:</span>
            All information required above shall be confirmed by email during the order confirmation process, with
            exception to the CVV2 Code, using only the last four digits of the credit card and all other pertinent
            information, as furnished at time of information collection on the telephone.
          </p>
          <p>
            <span class="font-weight-bold">DELIVERY OF GOODS AND SERVICES:</span>
            Delivery of Goods and Services that are remunerated by credit card payment shall be subject to
            confirmation of payment receipt in full at the sole discretion of Redbridge. Normal confirmation
            periods for credit cards payment can range between 2 to 4 business days.
          </p>
          <p>
              <span class="font-weight-bold">TRANSACCION TERMS AND LIMITATIONS:</span>
            Redbridge takes responsibility for all aspects relating to the transaction including sale of services
            offered on this website, customer service and support, dispute resolution. By using a credit/debit
            card to pay for your services, you confirm that the card being used is yours. All credit card holders
            are subject to validation checks and authorization by the card issuer and we are not obligated to
            inform you of the reason for any refusal. Redbridge bears no responsible for your card issuer or bank
            charging you as a result of our processing of your credit/debit card payment in accordance with your
            instruction. Furthermore, we cannot be responsible for any losses you may incur in transmitting
            information to Redbridge by internet link or by email. Any such loss shall not be borne, either wholly
            or in part, by Redbridge, and shall be entirely your responsibility.
          </p>
          <p>
            <span class="font-weight-bold">CANCELLATION AND REFUND:</span>
            If you change your mind about purchasing our services and cancel, by sending us an email to
            service#&64blueassist.com, more than 72 hours prior to the scheduled departure of your trip, we
            will refund the cost less 20% of the total price or US$20.00, whichever amount is higher, fees and
            taxes; if any. The refund will be made by the same method of payment you used to purchase of service.
            We will not issue a refund if the request for cancellation is received by us less than 72 hours prior
            to the schedule departure date of your trip.
          </p>
          <p class="font-weight-bold">UTILIZATION POLICY TERMS AND CONDITIONS</p>
          <p>
            <span class="font-weight-bold">REDBRIDGE TRAVEL ASSIST, S.A.</span>
            along with its subsidiaries and affiliates, (“Redbridge”) provides the information and services on its
            World Wide Web site (“Site”) under the following terms and conditions. By accessing and or using this
            Site, you (“User”) accept all terms and conditions.
          </p>
          <p>
            <span class="font-weight-bold">LAW AND REGULATIONS:</span>
            Access to and use of this Site is subject to all applicable laws and regulations. User agrees not to
            use this Site in any way that violates these rules and regulations.
          </p>
          <p>
            <span class="font-weight-bold">COPYRIGHT ABD TRADEMARKS:</span> 
            The information available on or through this Site is the property of Redbridge, or its licensors, and
            is protected by copyright, trademark or other intellectual property laws. Users may not modify copy,
            distribute, transmit, display, publish, sell, license, create derivative works or in any other way use
            any information available on or through this Site for commercial purposes. Users may not use the
            trademarks, logos and service marks (“Marks”) including, but not limited, to use as “hot links” or
            “meta tags” on other pages or sites on the World Wide Web without the prior, written consent of
            Redbridge.
          </p>
          <p>
            <span class="font-weight-bold">TAMPERING:</span>
            User agrees not to modify, move, add to, delete or otherwise tamper with the information contained in
            this Site. User also agrees not to decompile, reverse engineer, disassemble, or unlawfully use or
            reproduce any of the software or other proprietary material contained in this Site.
          </p>
          <p>
            <span class="font-weight-bold">LINKS TO OTHER SITES:</span>
            This Site may contain links to other web sites that are not under Redbridge’s control. This is done as
            a convenience and Redbridge does not endorse or assumes responsibility or liability for the content of
            these sites.
          </p>
          <p>
            <span class="font-weight-bold">LINKS FROM OTHER SITES:</span>
            Redbridge prohibits unauthorized links to the Site and the framing of any information contained
            herein. Redbridge reserves the right to disable any authorized links or frames. Redbridge is not
            responsible or liable for any information on other web sites that may contain a link to this Site.
          </p>
          <p>
            <span class="font-weight-bold">THIRD PARTY INFORMATION:</span>
            Some of the information on this Site may be provided to third parties. While Redbridge makes every
            commercially reasonable effort to ensure the accuracy of the information on this Site, it does not
            warrant the accuracy or completeness of any information.
          </p>
          <p>
            <span class="font-weight-bold">NO WARRANTIES:</span>
            Information and documents provided on this Site are provided without any warranty of any kind, either
            express or implied, including without limitation, warranties or merchantability, fitness for a
            particular purpose and non-infringement. Redbridge does not make any warranties or representations as
            to the accuracy of completeness of any information on this Site. Redbridge, from time to time, may
            add, change or delete information and documents on this Site without notice. Redbridge assumes no
            responsibility or liability for errors and omissions on this Site. Users access and use this Site at
            their own risk.
          </p>
          <p>
            <span class="font-weight-bold">LIIMITATION OF LIABILITY:</span>
            Under no circumstances shall Redbridge be liable for any damages suffered by a User, including any
            incidental, special or consequential damages, that result from access, use or inability to use this
            Site, or due to any breach of security associated with the transmission of information through the
            internet, even if Redbridge was advised of the possibility of such damages.
          </p>
          <p>
            <span class="font-weight-bold">PRIVACY:</span>
            Please refer to Redbridge’s Privacy Statement.
          </p>
          <p>
            <span class="font-weight-bold">SECURITY:</span>
            The security of information transmitted through the internet cannot guarantee. Redbridge is not
            responsible for any interception or interruption of any communications through the internet or for
            changes to or losses of data. User is responsible for the security of any passwords, user id or other
            forms of authentication.
          </p>
          <p>
            <span class="font-weight-bold">TRANSMISSION OF PERSONAL DATA</span>
            User acknowledges and agrees that by providing Redbridge with any personal information through this
            Site, User is consenting to the transmission of such information across the international borders.
          </p>
          <p>
            <span class="font-weight-bold">ACCESS TO PASSWORD PROTECTED AREAS:</span>
            Access to and uses of password protected areas on this Site are restricted to authorized users only.
            Unauthorized access to such areas is prohibited.
          </p>
          <p class="font-weight-bold">PRIVACY STATEMENT</p>
          <p>
            <span class="font-weight-bold">REDBRIDGE TRAVEL ASSIST, S.A.</span>
            respects and makes every commercially reasonable effort to protect your (User) privacy. The following
            principles govern our information and privacy practices on this web-site (“Site”).
          </p>
          <p>
            <span class="font-weight-bold">USE OF INFORMATION.</span>
            Non-personal information may be used to tract the number of visitors to this Site. This information is
            strictly for international use and is not shared with third parties. Personally identifiable
            information such as name, address and identification numbers is collected only when voluntary provided
            by the User and only for the identified purposes. We will not disclose your personal information
            without your permission except for the purpose of fulfilling your request for information, products or
            services offered on this Site. We will not sell your information without your consent.
          </p>
          <p>
            <span class="font-weight-bold">LEGAL REQUIREMENT.</span>
            We may need to disclose personally identifiable information when required by law, such as when
            necessary to comply with a government mandate, judicial proceeding, court order or other legal
            process.
          </p>
          <p>
            <span class="font-weight-bold">OTHER WEBSITES.</span>
            This Site may contain links to other web sites with different privacy statements and practices. We are
            not liable or responsible for the privacy statements of any other web site.
          </p>
          <p>
            <span class="font-weight-bold">CONFIDENTIALITY.</span>
            We make every commercially reasonable effort to protect the personal information of our Users from
            loss or unauthorized use. We restrict access to your personal information to our employees and
            authorized representatives and others who need to know this information, products and services you
            have requested. We maintain physical, electronic and procedural safeguards to protect confidential
            information.
          </p>
          <p>
            <span class="font-weight-bold">MODIFICATIONS.</span>
            This Privacy Statement is subject to change without notice; but any changes will be posted on this
            page of our Site.
          </p>
        </div>
        <div class="aceptar-checkbox">
          <label class="aceptar-block">One
            <input type="checkbox" checked="checked">
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="plandetails payment-info-section">
  <!-- Policy Details -->
  <div class="policy-details-toggle">
    <p (click)="toggleSection()" class="clickable-text">
      <span class="font-weight-bold">Detalles de Poliza</span>
      <span>Desplegar</span>
    </p>
    <div [class.show]="isSectionVisible" class="toggle-section">
      <div class="policy-details">
  
        <h4>Policy Details</h4>
        <div class="policy-info">
          <div class="policy-info-box">
            <span class="policy-info-box-title policy-target-blue">Destino North America</span>
            <a href="javascript:void(0)" class="info-box-edit">
              <img src="/assets/external/edit.png" alt="edit">
            </a>
          </div>
          <div class="policy-info-box">
            <span class="policy-info-box-title policy-user-blue">2 Personas</span>
            <a href="javascript:void(0)" class="info-box-edit">
              <img src="/assets/external/edit.png" alt="edit">
            </a>
          </div>
          <div class="policy-info-box">
            <span class="policy-info-box-title policy-date-blue">6 días</span>
            <a href="javascript:void(0)" class="info-box-edit">
              <img src="/assets/external/edit.png" alt="edit">
            </a>
          </div>
        </div>
        <!-- <div class="button-box">
          <button type="button" [disabled]="isBusy" class="btn btn-primary" data-bs-toggle="modal"
            data-bs-target="#sendQuoteByEmailModal">Enviar Correo</button>
        </div> -->
      </div>
    </div>
  </div>
  <!-- <div class="policy-details m-none">
    <h4>Policy Details</h4>
    <div class="policy-info">
      <div class="policy-info-box">
        <span class="policy-info-box-title policy-target-blue">Destino North America</span>
        <a href="javascript:void(0)" class="info-box-edit">
          <img src="/assets/external/edit.png" alt="edit">
        </a>
      </div>
      <div class="policy-info-box">
        <span class="policy-info-box-title policy-user-blue">2 Personas</span>
        <a href="javascript:void(0)" class="info-box-edit">
          <img src="/assets/external/edit.png" alt="edit">
        </a>
      </div>
      <div class="policy-info-box">
        <span class="policy-info-box-title policy-date-blue">6 días</span>
        <a href="javascript:void(0)" class="info-box-edit">
          <img src="/assets/external/edit.png" alt="edit">
        </a>
      </div>
    </div>
    <div class="button-box">
      <button class="btn btn-primary">Enviar Correo</button>
    </div>
  </div> -->
  <!-- primary Update -->
  <div class="planupadte-box primary-plan">
    <h4>Primary</h4>
    <div class="plan-price">
      <h2>$ 695.54</h2>
      <span class="blue-text">Cobertura por $50.000</span>
      <span class="gray-text">Precio expresado en dólares de los EE.UU.</span>
      <div class="plan-price-info">
        <div class="plan-price-info-box">
          <span class="plan-price-info-box-title">Coberturas Opcionales Seleccionadas</span>
          <div class="plan-price-value-table">
            <span>Cancelación por viaje castast..</span>
            <span class="text-bold">$2.500</span>
            <span>+ $27.20</span>
          </div>
          <div class="plan-price-value-table plan-price-value-table-active">
            <span>Deportes</span>
            <span class="text-bold">Titular<br />Dep.3</span>
            <span>+ $17.20<br />+ $27.20</span>
          </div>
          <div class="plan-price-value-table plan-price-value-table-active">
            <span>Preexistencias</span>
            <span class="text-bold">Titular</span>
            <span>+ $27.20</span>
          </div>
          <div class="plan-price-value-table">
            <span>Mascotas</span>
            <span class="text-bold">1</span>
            <span>+$8.64</span>
          </div>
          <div class="plan-price-value-table">
            <span>Futura Mamá</span>
            <span class="text-bold">Titular</span>
            <span>+ 0 USD</span>
          </div>
          <div class="plan-price-value-table">
            <span>Asistencia Legal VIP</span>
            <span class="text-bold">No</span>
            <span>+ 0 USD</span>
          </div>
        </div>
      </div>
      <div class="button-box">
        <button class="btn btn-primary">Enviar por Correo</button>
      </div>
    </div>
  </div>
  <div class="payment-info">
    <form novalidate class="p-5 form-general-style">
      <div class="p-3 background-effect mb-2">
        <span style="font-size: 11px;">Por favor, confirme los datos del comprador. Recuerde que estos pueden ser
          distintos a los del asegurado.</span>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="applicantName"
              id="firstName" onclick="this.setAttribute('value', this.value);" value="" >
            <label for="firstName" class="form-input-label">Nombres *</label>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 pl-lg-0">
          <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="applicantLastName"
              id="lastName" onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Apellidos *</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div class="form-group pt-0">
            <app-dropdown [options]="countries" formControlName="phoneCode" label="Código *"
              icon="/assets/external/localization-vector.svg">
              <ng-template #optionTemplate let-item>
                <div class="d-flex align-items-center">
                  <img *ngIf="item?.flag" [src]="item.flag" class="flag-icon mr-2" width="20" alt="{{ item?.name }}">
                  <span>{{ item?.code }} {{ item?.phoneCode ? ' (' + item?.phoneCode + ')' : '' }}</span>
                </div>
              </ng-template>
            </app-dropdown>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="applicantPhone"
              id="phoneNumber" onclick="this.setAttribute('value', this.value);" value="">
            <label for="phoneNumber" class="form-input-label">Telefono de contacto</label>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="applicantEmail"
              id="email" onclick="this.setAttribute('value', this.value);" value="">
            <label for="email" class="form-input-label">Correo Electrónico*</label>

          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="p-4 background-effect">
          <div class="d-flex" style="justify-content: space-between; align-items: center;">
            <span style="font-size: 11px;">Los Términos y Condiciones deben ser leidos y aceptados para poder continuar.
              <button type="button" style="font-weight: 590;" data-toggle="modal" data-target="#exampleModalCenter">
                Leer terminos y condiciones</button></span>
              
            <p-inputSwitch formControlName="checkedMarketing" />
          </div>
        </div>
      </div>
    </form>
    <form novalidate class="mt-4 p-5 form-general-style">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="applicantName"
              id="firstName" onclick="this.setAttribute('value', this.value);" value="">
            <label for="firstName" class="form-input-label">Nombre del Comprador</label>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="applicantLastName"
              id="lastName" onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Número de Tarjeta</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="applicantLastName"
              id="lastName" onclick="this.setAttribute('value', this.value);" value="">
            <label for="lastName" class="form-input-label">Pais</label>
          </div>
        </div>

        <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
          <div class="form-group">
            <input type="text" class="form-control form-input input-form-full-space" formControlName="applicantPhone"
              id="phoneNumber" onclick="this.setAttribute('value', this.value);" value="">
            <label for="phoneNumber" class="form-input-label">CVV</label>
          </div>
        </div>
      </div>
      <div class="form-group label-text-center">
        <div class="row">
          <div class="col form-group">

            <input type="text" class="form-control form-input input-form-full-space"
              onkeyup="this.setAttribute('value', this.value);" value="">
            <label for="selectedDay" class="form-input-label">Día *</label>


          </div>
          <div class="col form-group">
            <input type="text" class="form-control form-input input-form-full-space"
              onkeyup="this.setAttribute('value', this.value);" value="">
            <label for="monthDay" class="form-input-label">Mes *</label>


          </div>
          <div class="col form-group">
            <input type="text" class="form-control form-input xxinput-form-full-space"
              onkeyup="this.setAttribute('value', this.value);" value="">
            <label for="yearDay" class="form-input-label">Año *</label>


          </div>
        </div>
      </div>
      <div class="payment-card">
        <img src="/assets/external/Mastercard.png" alt="Mastercard">
        <img src="/assets/external/Visa.png" alt="Visa">
      </div>
      <div class="button-box mt-4 ">
        <button class="btn btn-primary">Pagar</button>
      </div>
    </form>
  </div>
</div>
  <!-- <div class="row pb-3">
    <div class="col-12 d-flex justify-content-center">
      <div class="p-4 form-general-style col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
        <div class="row">
          <div class="col-6">
              <label for="firstName" class="label-form-style-light mr-2">Titular:</label>
              <label id="firstName" class="label-form-style">{{quoteService.quoteModel?.applicantName}} {{quoteService.quoteModel?.applicantLastName}}</label>
          </div>
          <div class="col-6">
            <label for="agencyName" class="label-form-style-light mr-2">Código:</label>
            <label id="agencyName" class="label-form-style">{{agencyName}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
              <label for="email" class="label-form-style-light mr-2">E-mail:</label>
              <label id="email" class="label-form-style">{{quoteService.quoteModel?.applicantEmail}}</label>
          </div>
          <div class="col-6">
            <label for="dependentCount" class="label-form-style-light mr-2">No. de Dependientes:</label>
            <label id="dependentCount" class="label-form-style">{{dependentCount}}</label>
        </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label for="phone" class="label-form-style-light mr-2">Teléfono:</label>
            <label id="phone" class="label-form-style">{{quoteService.quoteModel?.applicantPhone}}</label>
          </div>
          <div class="col-6">
            <label for="dependentCountOver65" class="label-form-style-light mr-2">Dependientes 65+:</label>
            <label id="dependentCountOver65" class="label-form-style">{{dependentCountOver65}}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label for="birthdate" class="label-form-style-light mr-2">Fecha de nacimiento:</label>
            <label id="birthdate" class="label-form-style">{{quoteService.quoteModel?.applicantBirthdate | date:'dd-MM-yyyy' }}</label>
          </div>
          <div class="col-6">
            <label for="travelDuration" class="label-form-style-light mr-2">No. de días:</label>
            <label id="travelDuration" class="label-form-style">{{travelDuration}} días</label>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label for="residenceCountry" class="label-form-style-light mr-2">País de residencia:</label>
            <label id="residenceCountry" class="label-form-style">{{residenceCountry}}</label>
          </div>
          <div class="col-6">
              <label for="tripStartDate" class="label-form-style-light mr-2">Fecha de inicio:</label>
              <label id="tripStartDate" class="label-form-style">{{quoteService.quoteModel?.tripStartDate | date:'dd-MM-yyyy' }}</label>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <label for="destinationRegion" class="label-form-style-light mr-2">Región de destino:</label>
            <label id="destinationRegion" class="label-form-style">{{destinationRegion}}</label>
          </div>
          <div class="col-6">
            <label for="tripEndDate" class="label-form-style-light mr-2">Hasta:</label>
            <label id="tripEndDate" class="label-form-style">{{quoteService.quoteModel?.tripEndDate | date:'dd-MM-yyyy'}}</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row pb-5">
    <div class="col-12 d-flex justify-content-center">

      <div class="p-4 form-general-style col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">

        <div class="table-responsive" style="max-height:500px;">
          <div class="table-responsive">

            <table class="table table-bordered text-center" style="width: 100%;">
              <thead>
                <tr>
                  <th scope="row">Cobertura Máxima</th>
                  <th class="{{ coverageSelected == _coverage50k ? 'blueassist-text-color' : ''}}">{{(model50k.maxCoverage?.value ?? 0) | currency:'USD':'symbol'}}</th>
                  <th class="{{ coverageSelected == _coverage100k ? 'blueassist-text-color' : ''}}">{{(model100k.maxCoverage?.value ?? 0) | currency:'USD':'symbol'}}</th>
                  <th class="{{ coverageSelected == _coverage250k ? 'blueassist-text-color' : ''}}">{{(model250k.maxCoverage?.value ?? 0) | currency:'USD':'symbol'}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="col" class="col-6">Precio Total</th>
                  <td scope="col" class="col-2 {{ coverageSelected == _coverage50k ? 'blueassist-text-color' : ''}}">{{model50k.price | currency:'USD':'symbol'}} </td>
                  <td scope="col" class="col-2 {{ coverageSelected == _coverage100k ? 'blueassist-text-color' : ''}}">{{model100k.price | currency:'USD':'symbol'}}</td>
                  <td scope="col" class="col-2 {{ coverageSelected == _coverage250k ? 'blueassist-text-color' : ''}}">{{model250k.price | currency:'USD':'symbol'}}</td>
                </tr>
                <tr>
                  <th>Cobertura Básica</th>
                  <td class="{{ coverageSelected == _coverage50k ? 'blueassist-text-color' : ''}}">{{(model50k.maxCoverage?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage100k ? 'blueassist-text-color' : ''}}">{{(model100k.maxCoverage?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage250k ? 'blueassist-text-color' : ''}}">{{(model250k.maxCoverage?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                </tr>
                <tr>
                  <th scope="row">Cancelación de viaje por evento castastrófico</th>
                  <td class="{{ coverageSelected == _coverage50k ? 'blueassist-text-color' : ''}}">{{(model50k.cancellationDueToCatastrophicTrip?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage100k ? 'blueassist-text-color' : ''}}">{{(model100k.cancellationDueToCatastrophicTrip?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage250k ? 'blueassist-text-color' : ''}}">{{(model250k.cancellationDueToCatastrophicTrip?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                </tr>
                <tr>
                  <th scope="row">Deportes</th>
                  <td class="{{ coverageSelected == _coverage50k ? 'blueassist-text-color' : ''}}">{{(model50k.sportPractice?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage100k ? 'blueassist-text-color' : ''}}">{{(model100k.sportPractice?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage250k ? 'blueassist-text-color' : ''}}">{{(model250k.sportPractice?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                </tr>
                <tr>
                  <th scope="row">Preexistencias</th>
                  <td class="{{ coverageSelected == _coverage50k ? 'blueassist-text-color' : ''}}">{{(model50k.preexistingMedicalConditions?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage100k ? 'blueassist-text-color' : ''}}">{{(model100k.preexistingMedicalConditions?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage250k ? 'blueassist-text-color' : ''}}">{{(model250k.preexistingMedicalConditions?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                </tr>
                <tr>
                  <th scope="row">Mascotas</th>
                  <td class="{{ coverageSelected == _coverage50k ? 'blueassist-text-color' : ''}}">{{(model50k.pets?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage100k ? 'blueassist-text-color' : ''}}">{{(model100k.pets?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage250k ? 'blueassist-text-color' : ''}}">{{(model250k.pets?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                </tr>
                <tr>
                  <th scope="row">Futura Mamá</th>
                  <td class="{{ coverageSelected == _coverage50k ? 'blueassist-text-color' : ''}}">{{(model50k.futureMom?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage100k ? 'blueassist-text-color' : ''}}">{{(model100k.futureMom?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage250k ? 'blueassist-text-color' : ''}}">{{(model250k.futureMom?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                </tr>
                <tr>
                  <th scope="row">Asistencia Legal VIP</th>
                  <td class="{{ coverageSelected == _coverage50k ? 'blueassist-text-color' : ''}}">{{(model50k.legalVipAssistance?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage100k ? 'blueassist-text-color' : ''}}">{{(model100k.legalVipAssistance?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                  <td class="{{ coverageSelected == _coverage250k ? 'blueassist-text-color' : ''}}">{{(model250k.legalVipAssistance?.rate ?? 0) | currency:'USD':'symbol'}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <table class="table table-bordered text-center"> 
            <tbody>
              <tr>
                <th scope="row">N°</th>
                <th colspan="4">BENEFICIOS</th>
              </tr>
              <tr>
                <th scope="row">I</th>
                <th colspan="4">SERVICIO MEDICO POR EMERGENCIA</th>
              </tr>
              <tr>
                <th scope="row" rowspan="3">1</th>
                <td>
                  Servicios hospitalarios para la
                  estabilización y tratamiento de una
                  Emergencia incluyendo,pero sin
                  estar limitados a:
                  <ul>
                    <li>Servicios de emergencia para
                      pacientes internos y
                      ambulatorios.
                    </li>
                    <li>Anestesia, transfusión de
                      sangre, oxigeno.</li>
                    <li>Yesos, vendajes, cabestrillos,
                      etc.</li>
                    <li>Telemedicina.</li>
                  </ul>
                </td>
                <td>
                  Límite máximo por persona
                  por periodo de vigencia:
                  USD $50,000
                  Los servicios solo serán
                  provistos hasta que cese la
                  Emergencia.
                </td>
                <td>
                  Límite máximo por persona
                  por periodo de vigencia:
                  USD $ 100,000
                  Los servicios solo serán
                  provistos hasta que cese la
                  Emergencia.
                </td>
                <td>
                  Límite máximo por persona
                  por periodo de vigencia:
                  USD $ 250,000
                  Los servicios solo serán
                  provistos hasta que cese la
                  Emergencia.
                </td>
              </tr>
              <tr>
                <td>
                  Servicios médicos por condiciones
                  preexistentes, limitado.
                </td>
                <td>
                  $750 - para planes con
                  límite máximo de $50.000.
                  $1,000 - para planes con
                  límite máximo de $100.000.
                  $1,500 - para planes con
                  límite máximo de $250.000.
                </td>
                <td>
                  $750 - para planes con
                  límite máximo de $50.000.
                  $1,000 - para planes con
                  límite máximo de $100.000.
                  $1,500 - para planes con
                  límite máximo de $250.000.
                </td>
                <td>
                  $750 - para planes con
                  límite máximo de $50.000.
                  $1,000 - para planes con
                  límite máximo de $100.000.
                  $1,500 - para planes con
                  límite máximo de $250.000.
                </td>
              </tr>
  
              <tr>
                <td>
                  Covid-19 - Coronavirus. Dos (2)
                  pruebas de detección medicamente
                  necesarias.Excluye la primera (1ra)
                  prueba de detección realizada a su
                  llegada al país de destino en el
                  extranjero.
                </td>
                <td>
                  Hasta el límite máximo
                  indicado en el Inciso N°.1.
                  (arriba)
                </td>
                <td>
                  Hasta el límite máximo
                  indicado en el Inciso N°.1.
                  (arriba)
                </td>
                <td>
                  Hasta el límite máximo
                  indicado en el Inciso N°.1.
                  (arriba)
                </td>
              </tr>
  
              <tr>
                <th role="row">2</th>
                <td>
                  Servicios de médicos y especialistas
                  para el cuidado, tratamiento o
                  cirugía requeridos por una
                  emergencia.
                </td>
                <td>
                  Hasta la cantidad indicada
                  en el Inciso N°.1 (arriba)
                </td>
                <td>
                  Hasta la cantidad indicada
                  en el Inciso N°.1 (arriba)
                </td>
                <td>
                  Hasta la cantidad indicada
                  en el Inciso N°.1 (arriba)
                </td>
              </tr>
  
              <tr>
                <th role="row">3</th>
                <td>
                  Medicamentos prescritos
                  requeridos por una emergencia.
                </td>
                <td>
                  $750
                </td>
                <td>
                  $750
                </td>
                <td>
                  $750
                </td>
              </tr>
  
              <tr>
                <th role="row">4</th>
                <td>
                  Pruebas de diagnóstico y
                  procedimientos requeridos por una
                  emergencia.
                </td>
                <td>
                  Hasta la cantidad indicada
                  en el Inciso N°.1 (arriba).
                </td>
                <td>
                  Hasta la cantidad indicada
                  en el Inciso N°.1 (arriba).
                </td>
                <td>
                  Hasta la cantidad indicada
                  en el Inciso N°.1 (arriba).
                </td>
              </tr>
  
              <tr>
                <th role="row">5</th>
                <td>
                  Emergencia dental.
                </td>
                <td>
                  $750
                </td>
                <td>
                  $750
                </td>
                <td>
                  $750
                </td>
              </tr>
  
              <tr>
                <th role="row">II</th>
                <th colspan="4">
                  SERVICIOS DE ASISTENCIA POR EMERGENCIA
                </th>
              </tr>
  
              <tr>
                <th role="row">1</th>
                <td>
                  Traslado terrestre o aéreo por
                  emergencia médica.
                </td>
                <td>
                  $50,000
                </td>
                <td>
                  $50,000
                </td>
                <td>
                  $50,000
                </td>
              </tr>
  
              <tr>
                <th role="row">2</th>
                <td>
                  Repatriación
                  por emergencia médica.
                </td>
                <td>
                  $50,000
                </td>
                <td>
                  $50,000
                </td>
                <td>
                  $50,000
                </td>
              </tr>
  
              <tr>
                <th role="row">3</th>
                <td>
                  Estadía en hotel por convalecencia
                  prescrita resultante de una
                  emergencia.
                </td>
                <td>
                  $100 diarios,
                  máximo 10 días
                </td>
                <td>
                  $100 diarios,
                  máximo 10 días
                </td>
                <td>
                  $100 diarios,
                  máximo 10 días
                </td>
              </tr>
  
              <tr>
                <th role="row">4</th>
                <td>
                  Estadía en hotel por resultado positivo
                  de la prueba COVID-19 en el extranjero,
                  limitado a:
                </td>
                <td>
                  $2,000
                </td>
                <td>
                  $2,000
                </td>
                <td>
                  $2,000
                </td>
              </tr>
  
              <tr>
                <th role="row">5</th>
                <td>
                  Traslado de un acompañante por una
                  hospitalización superior a 5 días
                  Resultante de una emergencia.
                </td>
                <td>
                  $1,000
                </td>
                <td>
                  $1,000
                </td>
                <td>
                  $1,000
                </td>
              </tr>
  
              <tr>
                <th role="row">6</th>
                <td>
                  Estadía en hotel para acompañante.
                </td>
                <td>
                  $100 diarios, máximo 10 días
                </td>
                <td>
                  $100 diarios, máximo 10 días
                </td>
                <td>
                  $100 diarios, máximo 10 días
                </td>
              </tr>
  
              <tr>
                <th role="row">7</th>
                <td>
                  Garantía de regreso (fecha diferente a
                  la programada).
                </td>
                <td>
                  $500 - diferencia en el costo del
                  pasaje o penalidad Impuesta
                </td>
                <td>
                  $500 - diferencia en el costo del
                  pasaje o penalidad Impuesta
                </td>
                <td>
                  $500 - diferencia en el costo del
                  pasaje o penalidad Impuesta
                </td>
              </tr>
  
              <tr>
                <th role="row">8</th>
                <td>
                  Regreso de menores de 15 años.
                </td>
                <td>
                  $5,000
                </td>
                <td>
                  $5,000
                </td>
                <td>
                  $5,000
                </td>
              </tr>
  
              <tr>
                <th role="row">9</th>
                <td>
                  Repatriación de restos mortales.
                </td>
                <td>
                  $35,000
                </td>
                <td>
                  $35,000
                </td>
                <td>
                  $35,000
                </td>
              </tr>
  
              <tr>
                <th role="row">10</th>
                <td>
                  Asistencia legal.
                </td>
                <td>
                  $1,500
                </td>
                <td>
                  $1,500
                </td>
                <td>
                  $1,500
                </td>
              </tr>
  
              <tr>
                <th role="row">11</th>
                <td>
                  Gastos por fianza
                </td>
                <td>
                  $1,500
                </td>
                <td>
                  $1,500
                </td>
                <td>
                  $1,500
                </td>
              </tr>
  
              <tr>
                <th role="row">12</th>
                <td>
                  Servicios de remolque para vehículo
                  alquilado.
                </td>
                <td>
                  $100
                </td>
                <td>
                  $100
                </td>
                <td>
                  $100
                </td>
              </tr>
  
              <tr>
                <th role="row">13</th>
                <td>
                  Vuelo demorado o cancelado.
                </td>
                <td>
                  $300
                </td>
                <td>
                  $300
                </td>
                <td>
                  $300
                </td>
              </tr>
  
              <tr>
                <th role="row">14</th>
                <td>
                  Localización de equipaje.
                </td>
                <td>
                  Llamada de asistencia
                </td>
                <td>
                  Llamada de asistencia
                </td>
                <td>
                  Llamada de asistencia
                </td>
              </tr>
  
              <tr>
                <th role="row">15</th>
                <td>
                  Demora de equipaje superior a 72
                  horas.
                </td>
                <td>
                  $150
                </td>
                <td>
                  $150
                </td>
                <td>
                  $150
                </td>
              </tr>
  
              <tr>
                <th role="row">16</th>
                <td>
                  Demora de equipaje superior a 12 días.
                </td>
                <td>
                  $200
                </td>
                <td>
                  $200
                </td>
                <td>
                  $200
                </td>
              </tr>
  
              <tr>
                <th role="row">17</th>
                <td>
                  Pérdida definitiva de equipaje.
                </td>
                <td>
                  $20 por kilogramo de peso del equipaje, hasta $1,000
                </td>
                <td>
                  $20 por kilogramo de peso del equipaje, hasta $1,000
                </td>
                <td>
                  $20 por kilogramo de peso del equipaje, hasta $1,000
                </td>
              </tr>
  
              <tr>
                <th role="row">18</th>
                <td>
                  Regreso por fallecimiento de familiar
                  inmediato.
                </td>
                <td>
                  $500 - diferencia en el costo del pasaje o penalidad impuesta
                </td>
                <td>
                  $500 - diferencia en el costo del pasaje o penalidad impuesta
                </td>
                <td>
                  $500 - diferencia en el costo del pasaje o penalidad impuesta
                </td>
              </tr>
  
              <tr>
                <th role="row">19</th>
                <td>
                  Regreso por pérdida catastrófica en su
                  domicilio
                </td>
                <td>
                  $500 - diferencia en el costo del
                  pasaje o penalidad impuesta
                </td>
                <td>
                  $500 - diferencia en el costo del
                  pasaje o penalidad impuesta
                </td>
                <td>
                  $500 - diferencia en el costo del
                  pasaje o penalidad impuesta
                </td>
              </tr>
  
              <tr>
                <th role="row">20</th>
                <td>
                  Pérdida de conexión aérea.
                </td>
                <td>
                  $150
                </td>
                <td>
                  $150
                </td>
                <td>
                  $150
                </td>
              </tr>
  
              <tr>
                <th role="row">21</th>
                <td>
                  Pérdida de pasaporte.
                </td>
                <td>
                  $500-Gestión Consular
                </td>
                <td>
                  $500-Gestión Consular
                </td>
                <td>
                  $500-Gestión Consular
                </td>
              </tr>
  
              <tr>
                <th role="row">III</th>
                <th>
                  BENEFICIOS OPCIONALES
                </th>
                <th colspan="3">
                  LOS SIGUIENTES BENEFICIOS SOLOS SERÁN PROVISTOS SI LA PRIMA ADICIONAL HA SIDO PAGADA,
                  LA CANTIDAD LIMITE SE INDICA A CONTINUACIÓN Y EL BENEFICIO SE ESPECIFICA EN EL CERTIFICADO
                  EMITIDO POR LA COMPAÑÍA
                </th>
              </tr>
  
              <tr>
                <th role="row">1</th>
                <td>
                  CANCELACIÓN DE
                  VIAJE POR
                  EVENTO
                  CATASTRÓFICO
                </td>
                <td>
                  Indemnización por la pérdida de
                  los gastos prepagados, no
                  reembolsables, en relación con
                  una cancelación o interrupción
                  inevitable del viaje por una
                  causa cubierta.
                  Límite Máximo: $2,500
                </td>
                <td>
                  Indemnización por la pérdida
                  de los gastos prepagados, no
                  reembolsables, en relación
                  con una cancelación o
                  interrupción inevitable del
                  viaje por una causa cubierta.
                  Límite Máximo: $2,500
                </td>
                <td>
                  Indemnización por la pérdida
                  de los gastos prepagados, no
                  reembolsables, en relación
                  con una cancelación o
                  interrupción inevitable del
                  viaje por una causa cubierta.
                  Límite Máximo: $2,500
                </td>
              </tr>
  
              <tr>
                <th role="row">2</th>
                <td>
                  PRÁCTICA DE DEPORTES
                </td>
                <td>
                  Servicios de asistencia médica
                  para la estabilización y
                  tratamiento de una emergencia
                  médica por accidente resultado
                  de su participación en deportes.
                  Límite Máximo: $50,000
                  Incluido: Si
                </td>
                <td>
                  Servicios de asistencia médica
                  para la estabilización y
                  tratamiento de una
                  emergencia médica por
                  accidente resultado de su
                  participación en deportes.
                  Límite Máximo: $100,000
                  Incluido: Si
                </td>
                <td>
                  Servicios de asistencia médica
                  para la estabilización y
                  tratamiento de una
                  emergencia médica por
                  accidente resultado de su
                  participación en deportes.
                  Límite Máximo: $250,000
                  Incluido: Si
                </td>
              </tr>
  
              <tr>
                <th role="row">3</th>
                <td>
                  CONDICIONES
                  MÉDICAS
                  PREEXISTENTE
                </td>
                <td>
                  Servicios de asistencia médica
                  para la estabilización de una
                  emergencia médica resultado
                  de una condición preexistente.
                  El límite de esta cobertura será
                  el 30% de la cobertura máxima
                  seleccionada, sin exceder
                  $30,000.
                  Incluido: Si
                </td>
                <td>
                  Servicios de asistencia médica
                  para la estabilización de una
                  emergencia médica resultado
                  de una condición
                  preexistente. El límite de esta
                  cobertura será el 30% de la
                  cobertura máxima
                  seleccionada, sin exceder
                  $30,000.
                  Incluido: Si
                </td>
                <td>
                  Servicios de asistencia médica
                  para la estabilización de una
                  emergencia médica resultado
                  de una condición
                  preexistente. El límite de esta
                  cobertura será el 30% de la
                  cobertura máxima
                  seleccionada, sin exceder
                  $30,000.
                  Incluido: Si
                </td>
              </tr>
  
              <tr>
                <th role="row">4</th>
                <td>
                  FUTURA MAMÁ
                </td>
                <td>
                  Servicios de asistencia médica
                  para la estabilización de una
                  emergencia médica por
                  enfermedad o accidente
                  producto de su embarazo. Entre
                  12 semanas y 32 semanas de
                  vigencia máxima de 30 días
                  contados a partir del inicio de la
                  fecha del viaje en el
                  exterior.Límite Máximo $10,000
                </td>
                <td>
                  Servicios de asistencia médica
                  para la estabilización de una
                  emergencia médica por
                  enfermedad o accidente
                  producto de su embarazo.
                  Entre 12 semanas y 32
                  semanas de vigencia máxima
                  de 30 días contados a partir
                  del inicio de la fecha del viaje
                  en el exterior.Límite Máximo
                  $10,000
                </td>
                <td>
                  Servicios de asistencia médica
                  para la estabilización de una
                  emergencia médica por
                  enfermedad o accidente
                  producto de su embarazo.
                  Entre 12 semanas y 32
                  semanas de vigencia máxima
                  de 30 días contados a partir
                  del inicio de la fecha del viaje
                  en el exterior.Límite Máximo
                  $10,000
                </td>
              </tr>
  
              <tr>
                <th role="row">5</th>
                <td>
                  ASISTENCIA PARA MASCOTAS
                </td>
                <td>
                  Servicios de asistencia médica
                  para la estabilización de una
                  emergencia médica por
                  enfermedad no preexistente o
                  accidente de la mascota.
                  Límite Máximo $1.000 por
                  mascota.Máximo 3 (aplica para
                  perros y gatos únicamente)
                  Seleccionado: Si
                </td>
                <td>
                  Servicios de asistencia médica
                  para la estabilización de una
                  emergencia médica por
                  enfermedad no preexistente
                  o accidente de la mascota.
                  Límite Máximo $1.000 por
                  mascota. Máximo 3 (aplica
                  para perros y gatos
                  únicamente)
                  Seleccionado: No
                </td>
                <td>
                  Servicios de asistencia médica
                  para la estabilización de una
                  emergencia médica por
                  enfermedad no preexistente
                  o accidente de la
                  mascota.Límite Máximo
                  $1.000 por mascota.Máximo 3
                  (aplica para perros y gatos
                  únicamente)
                  Seleccionado: No
                </td>
              </tr>
  
              <tr>
                <th role="row">6</th>
                <td>
                  ASISTENCIA LEGAL VIP
                </td>
                <td>
                  Asistencia legal presencial
                  durante su viaje con apoyo local.
                  Seleccionado: Si
                </td>
                <td>
                  Asistencia legal presencial
                  durante su viaje con apoyo
                  local.
                  Seleccionado: Si
                </td>
                <td>
                  Asistencia legal presencial
                  durante su viaje con apoyo
                  local.
                  Seleccionado: Si
                </td>
              </tr>
  
              </tbody>
            </table>

        </div>

        <hr class="mx-4 my-4">
        <div class="row align-self-center">
          <div class="col-6">
              <div class="form-group">
                <button type="button" [disabled]="isBusy" class="btn btn-primary continue-btn-steps py-3" data-bs-toggle="modal" data-bs-target="#sendQuoteByEmailModal">Enviar por email</button>
              </div>   
          </div>
          <div class="col-6">
            <div class="form-group">
              <button type="button" (click)="downloadQuotePdf()" [disabled]="isBusy" class="btn btn-primary continue-btn-steps py-3">Descargar PDF</button>
            </div>  
          </div>
        </div>
      </div>
   
    </div>


    
    <div class="col-12 d-flex justify-content-center pt-3">      
      <form novalidate class="p-4 form-general-style col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
        <div class="row">
          <div class="col-12 pb-3 d-flex">
            <span class="span-style-term-header">
              Los Términos y Condiciones deben ser leidos y aceptados para poder continuar.
            </span>
          </div>

          <p-accordion class="w-full">
            <p-accordionTab header="POLITICA DE CANCELACION Y DEVOLUCION">
              <div class="row pb-2 pt-3" style="max-height: 250px; overflow: auto; font-size: 12px !important;">
                <div class="row">
                  <div class="col-12">
                    <p>
                      <strong>REQUISITOS DE LA INFORMACION:</strong>
                      La tramitación de una tarjeta de crédito requiere de la adquisición de la información pertinente, incluyendo el número de la tarjeta de crédito, fecha de expiración, nombre y el código CVV2, según aparece en la tarjeta de crédito. Información adicional podría incluir; pero no taxativamente la dirección de facturación de la tarjeta de crédito, un correo electrónico válido y número de teléfono del comprador, y la exención del impuesto de venta, cuandoaplique.
                    </p>
                    <p>
                      <strong>PROTECCION DE PRIVACIDAD:</strong>
                      En el momento de la compra y motivos de seguridad, un empleado administrativo de Redbridge podrá adquirir por teléfono la información requerida para procesarla tarjeta de crédito. Para su protección, la información no podrá ser transmitida ni será aceptada por otros métodos de transmisión como son el correo electrónico o facsímil. Redbridge tomara todos los pasos necesarios para proteger la información personal de los usuarios. Para el propósito de esta cláusula “información personal” deberá definirse como la información adquirida en el momento que se procesa la tarjeta de crédito.
                    </p>
                    <p>
                      <strong>CONFIRMACION DE LA TARJETA DE CREDITO:</strong>
                      Toda la información requerida previamente será confirmada por correo electrónico durante el proceso de confirmación de la orden, con la excepción del código CVV2, donde se utiliza únicamente los últimos cuatro dígitos de la tarjeta de crédito y cualquier otra información pertinente, según provista en el momento de adquirir la información por teléfono.
                    </p>
                    <p>
                      <strong>ENTREGA DE MERCANCIA Y SERVICIOS:</strong>
                      La entrega de servicios que son remunerados con pagos por tarjeta de crédito estará sujeta al recibo de confirmación del pago total bajo la única discreción de Redbridge. El periodo de confirmación normal fluctúa de 2 a 4 días laborables.
                    </p>
                    <p>
                      <strong>TERMINOS Y LIMITACIONES DE LA TRANSACCCION:</strong>
                      Redbridge acepta la responsabilidad en todo aspecto relacionados con la transacción incluyendo la venta de los servicios ofrecidos en este sitio-web, servicios al cliente, apoyo, resolución de disputas. Al utilizar su tarjeta de crédito para pagar por sus servicios, usted confirma ser el titular de la tarjeta utilizada. Todo titular de tarjeta de crédito está sujeto a chequeos de validación y autorización por la entidad emisora de la tarjeta y nosotros no estamos obligados a informarle la razón de cualquier rechazo. Redbridge no admite responsabilidad alguna de parte de la entidad emisora, ni por cargos impuestos en su tarjeta como resultado del procesamiento de su pago, en cumplimiento con su instrucción. Además, nosotros no seremos responsables por cualquier pérdida que usted pueda incurrir al trasmitir información a Redbridge por enlace (link) de internet o por correo electrónico. Redbridge no acepta responsabilidad alguna por pérdidas, parcial o total, y serán de su única responsabilidad.
                    </p>
                    <p>
                      <strong>CANCELACION Y DEVOLUCION:</strong>
                      Si usted cambia de parecer sobre la compra de nuestros servicios y cancela, al enviarnos un correo electrónico a service#&64blueassist.com, con más de 72 horas previas a la fecha de salida registrada de su viaje, nosotros le devolveremos el costo menos el 20% del precio total o un mínimo de US $20.00, la cantidad que sea mayor, e impuestos, si alguno. La devolución será realizada por el mismo método de pago que usted utilizo al comprar nuestros servicios. Nosotros no emitiremos devoluciones, cuando la solicitud de cancelación sea recibida por nosotros con 72 horas o meno previas a la fecha de salida registrada de su viaje.
                    </p>
                  </div>
                </div>
    
                
                <div class="row">
                  <div class="col-12 text-center">
                    <strong>TERMINOS Y CONDICIONES DE UTILIZACION</strong>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <p>
                      <strong>BLUEASSIST TRAVEL ASSIST</strong>
                       junto con sus subsidiarias y afiliadas, (“Redbridge”) provee la información y servicios en su Página Web Global (“Sitio”) bajo los siguientes términos y condiciones. Al accesar o utilizar este Sitio, usted (“Usuario”) acepta todos los términos y condiciones.
                    </p>
                    <p>
                      <strong>LEYES Y REGULACIONES:</strong>
                      El acceso y uso de este Sitio está sujeto a todas leyes y regulaciones aplicables. El Usuario acuerda no utilizar este Sitio de forma alguna que viole estas reglas y regulaciones. 
                    </p>
                    <p>
                      <strong>DERECHOS DE AUTOR Y MARCA REGISTRADA:</strong>
                      La información disponible en o a través de este Sitio es propiedad de Redbridge, o sus licenciantes, y está protegida por las leyes de los Derechos de Autor y Marca Registrada. Los Usuarios no pueden modificar, copiar, distribuir, transmitir, publicar, vender, licenciar, crear escritos derivados de, o de ninguna otra forma utilizar cualquier información disponible en o a través de este Sitio para uso comercial. Los Usuarios no pueden utilizar la marca registrada, logos y marcas de servicios (“Marcas”) incluyendo, taxativamente el uso de “enlaces clave” (hot links) o “portales registrados” (meta tags) en otras páginas o sitios en la Página Web Global sin el previo consentimiento escrito de Redbridge.
                    </p>
                    <p>
                      <strong>INOBSERVANCIAS:</strong>
                      El Usuario acuerda no modificar, mover, añadir a, eliminar o de otra manera infringir la información comprendida en este Sitio. El Usuario también acuerda no descompilar, revertir ingeniería, desarmar, o ilegalmente usar o reproducir cualquier programa u otra propiedad material comprendida en este Sitio.
                    </p>
                    <p>
                      <strong>ENLACES A OTROS SITIOS:</strong>
                      Este Sitio puede incluir enlaces a otros sitios-web que no están bajo el control de Redbridge. Esto es hecho por conveniencia y Redbride no aprueba ni asume obligación o responsabilidad civil por el contenido de estos sitios.
                    </p>
                    <p>
                      <strong>ENLACES DE OTROS SITIOS:</strong>
                      Redbridge prohíbe los enlaces no autorizados a este Sitio y la aplicación de cualquier información aquí comprendida. Redbridge se reserve el derecho de deshabilitar cualquier enlace o aplicación no autorizada. Redbridge no aprueba ni se responsabiliza por la información comprendida en cualquier otro sitio-web que pueda tener enlace con este Sitio.
                    </p>
                    <p>
                      <strong>INFORAMACION A TERCERAS PARTES:</strong>
                      Alguna de la información en este Sitio puede ser facilitada a terceras partes. Mientras que Redbridge realiza todo esfuerzo comercialmente razonable para atestar la exactitud de la información en este Sitio, esto no garantiza la exactitud y compleción de cualquier información.
                    </p>
                    <p>
                      <strong>NO GARANTIAS:</strong>
                      La información y documentos en este Sitio son provistos sin garantía de algún tipo, tanto expresa o implícita, incluyendo, sin limitación, garantías de comercialización, prácticas con particular propósito y no-infracción. Redbridge no ofrece garantías ni representaciones de la exactitud y compleción de cualquier información en este Sitio. Redbridge, de vez en cuando, podrá añadir, cambiar, o eliminar sin previo aviso, información y documentos de este Sitio. Redbridge no acepta obligación ni responsabilidad civil por errores y omisiones en este Sitio. Los usuarios acceden y utilizan este Sitio, bajo su responsabilidad.
                    </p>
                    <p>
                      <strong>LIMITE DE RESPONSABILIDAD:</strong>
                      Por ninguna circunstancia Redbridge deberá ser responsable por daños sufridos por el Usuario, incluyendo cualquier incidental, especifico o daño consecuente, que derive de acceder, utilizar o inhabilitar el uso de este Sitio, o por cualquier infracción de seguridad asociada con la transmisión de información a través de internet, incluso cuando Redbridge haya sido notificado de la posibilidad de dichos daños.
                    </p>
                    <p>
                      <strong>PRIVACIDAD:</strong>
                      Favor de referirse al Aviso de Privacidad de Redbridge, publicado en este Sitio.
                    </p>
                    <p>
                      <strong>SEGURIDAD:</strong>
                      La seguridad de la información transmitida a través de internet no es garantizada. Redbridge no es responsable por cualquier intercepción o interrupción de cualquier comunicación a través de internet o por cambios o perdida de datos. El Usuario es responsable por la seguridad de cualquier identificación, clave de seguridad o cualquier otra forma de autenticidad.
                    </p>
                    <p>
                      <strong>TRANSMISION DE DATOS PERSONALES:</strong>
                      El Usuario reconoce y acepta que al proveer a Redbridge con cualquier información personal a través de este Sitio, el Usuario consiente la trasmisión de dicha información a través de confines internacionales.
                    </p>
                    <p>
                      <strong>ACCESO DE AREAS PROTEGIDAS:</strong>
                      El acceso y uso de clave de seguridad en áreas protegidas de este Sitio se encuentra restricto a usuarios autorizados únicamente. El acceso no-autorizado está prohibido en dichas áreas.
                    </p>
                  </div>
                </div>
    
                
                <div class="row">
                  <div class="col-12 text-center">
                    <strong>AVISO DE PRIVACIDAD</strong>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <p>
                      <strong>BLUEASSIST TRAVEL ASSIST</strong>
                      obedece y realiza todo esfuerzo comercialmente posible para proteger su (Usuario) privacidad. Las normas a continuación rigen la información y práctica de privacidad nuestra en esta Página-Web (Sitio).
                    </p>
                    <p>
                      <strong>USO DE INFORMACION.</strong>
                      Información confidencial puede ser utilizada para rastrear el número de visitantes a este Sitio. Esta información es únicamente para uso interno y no es compartida con terceras partes. Información personal identificable como es, nombre, dirección y número de identificación solo se obtiene cuando el Usuario la provee voluntariamente y con el único propósito de identificación. Nosotros no divulgaremos su información sin su permiso, excepto con el propósito de cumplir con su solicitud de información, productos o servicios ofrecidos en este Sitio. Nosotros no negociaremos su información sin su consentimiento.
                    </p>
                    <p>
                      <strong>REQUISITO LEGAL.</strong>
                      Nosotros podríamos necesitar revelar su información personal confidencial cuando nos sea requerido por ley, como cuando sea necesario cumplir con un mandato gubernamental, procedimientos jurídicos, orden de la corte o cualquier otro proceso legal.
                    </p>
                    <p>
                      <strong>OTRAS PAGINA-WEB.</strong>
                      Este Sitio puede tener conexiones a otros sitios-web con avisos y prácticas de privacidad diferentes. Nosotros no somos responsables por los avisos o prácticas de privacidad de cualquier otro sitio-web.
                    </p>
                    <p>
                      <strong>CONFIDENCIALIDAD.</strong>
                      Nosotros haremos todo esfuerzo comercialmente posible para proteger la información confidencial de nuestros Usuarios contra daños o uso no-autorizado. El acceso a su información confidencial es restringido a nuestros empleados, representantes autorizados y otros que necesitan conocer de esta información para proveerle a usted con la información, productos y servicios que usted ha solicitado. Nosotros salvaguardamos los recursos tangibles, electrónicos y técnicos para proteger información confidencial.
                    </p>
                    <p>
                      <strong>MODIFICACIONES</strong>
                      Este Aviso de Privacidad está sujeto a cambios sin previa notificación; pero cualquier cambio será colocado en esta página, de nuestro Sitio-web.
                    </p>
                  </div>
                </div>
    
              </div>
            </p-accordionTab>

            <p-accordionTab header="CANCELLATION AND RETURN POLICY">
              <div class="row pb-2 pt-5" style="max-height: 250px; overflow: auto; font-size: 12px !important;">
                 <div class="row">
                  <div class="col-12">
                    <p>
                      <strong>INFORMATION REQUIREMENTS:</strong>
                      The processing of a credit card payment shall require the collection of pertinent information including the credit card number, expiration date, name and CVV2 code as it appears on the credit card. Additional required information shall include but not be limited to the credit card billing address, a valid email address and telephone number of the purchaser, and a valid sales tax exemption number when applicable.
                    </p>
                    <p>
                      <strong>PRIVACY PROTECTION:</strong>
                      For security purposes, credit card processing information shall be acquired by telephone at time of purchase order by authorized administrative personnel of Redbridge. Information may not be transmitted nor will it be accepted by other methods such as email or fax transmissions for your protection. Redbridge shall take all reasonable steps to protect the personal information of users. For the purpose of this clause, “personal information” shall be defined as all information collected at time of credit card payment processing.
                    </p>
                    <p>
                      <strong>CREDIT CARD INFORMATION CONFIRMATION:</strong>
                      All information required above shall be confirmed by email during the order confirmation process, with exception to the CVV2 Code, using only the last four digits of the credit card and all other pertinent information, as furnished at time of information collection on the telephone.
                    </p>
                    <p>
                      <strong>DELIVERY OF GOODS AND SERVICES:</strong>
                      Delivery of Goods and Services that are remunerated by credit card payment shall be subject to confirmation of payment receipt in full at the sole discretion of Redbridge. Normal confirmation periods for credit cards payment can range between 2 to 4 business days.
                    </p>
                    <p>
                      <strong>TRANSACCION TERMS AND LIMITATIONS:</strong>
                      Redbridge takes responsibility for all aspects relating to the transaction including sale of services offered on this website, customer service and support, dispute resolution. By using a credit/debit card to pay for your services, you confirm that the card being used is yours. All credit card holders are subject to validation checks and authorization by the card issuer and we are not obligated to inform you of the reason for any refusal. Redbridge bears no responsible for your card issuer or bank charging you as a result of our processing of your credit/debit card payment in accordance with your instruction. Furthermore, we cannot be responsible for any losses you may incur in transmitting information to Redbridge by internet link or by email. Any such loss shall not be borne, either wholly or in part, by Redbridge, and shall be entirely your responsibility.
                    </p>
                    <p>
                      <strong>CANCELLATION AND REFUND:</strong>
                      If you change your mind about purchasing our services and cancel, by sending us an email to service#&64blueassist.com, more than 72 hours prior to the scheduled departure of your trip, we will refund the cost less 20% of the total price or US$20.00, whichever amount is higher, fees and taxes; if any. The refund will be made by the same method of payment you used to purchase of service. We will not issue a refund if the request for cancellation is received by us less than 72 hours prior to the schedule departure date of your trip.
                    </p>
                  </div>
                </div>
    
               
                <div class="row">
                  <div class="col-12 text-center">
                    <strong>UTILIZATION POLICY TERMS AND CONDITIONS</strong>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <p>
                      <strong>REDBRIDGE TRAVEL ASSIST, S.A.</strong>
                      along with its subsidiaries and affiliates, (“Redbridge”) provides the information and services on its World Wide Web site (“Site”) under the following terms and conditions. By accessing and or using this Site, you (“User”) accept all terms and conditions.
                    </p>
                    <p>
                      <strong>LAW AND REGULATIONS:</strong>
                      Access to and use of this Site is subject to all applicable laws and regulations. User agrees not to use this Site in any way that violates these rules and regulations.
                    </p>
                    <p>
                      <strong>COPYRIGHT ABD TRADEMARKS:</strong>
                      The information available on or through this Site is the property of Redbridge, or its licensors, and is protected by copyright, trademark or other intellectual property laws. Users may not modify copy, distribute, transmit, display, publish, sell, license, create derivative works or in any other way use any information available on or through this Site for commercial purposes. Users may not use the trademarks, logos and service marks (“Marks”) including, but not limited, to use as “hot links” or “meta tags” on other pages or sites on the World Wide Web without the prior, written consent of Redbridge.
                    </p>
                    <p>
                      <strong>TAMPERING:</strong>
                      User agrees not to modify, move, add to, delete or otherwise tamper with the information contained in this Site. User also agrees not to decompile, reverse engineer, disassemble, or unlawfully use or reproduce any of the software or other proprietary material contained in this Site.
                    </p>
                    <p>
                      <strong>LINKS TO OTHER SITES:</strong>
                      This Site may contain links to other web sites that are not under Redbridge’s control. This is done as a convenience and Redbridge does not endorse or assumes responsibility or liability for the content of these sites.
                    </p>
                    <p>
                      <strong>LINKS FROM OTHER SITES:</strong>
                      Redbridge prohibits unauthorized links to the Site and the framing of any information contained herein. Redbridge reserves the right to disable any authorized links or frames. Redbridge is not responsible or liable for any information on other web sites that may contain a link to this Site.
                    </p>
                    <p>
                      <strong>THIRD PARTY INFORMATION:</strong>
                      Some of the information on this Site may be provided to third parties. While Redbridge makes every commercially reasonable effort to ensure the accuracy of the information on this Site, it does not warrant the accuracy or completeness of any information.
                    </p>
                    <p>
                      <strong>NO WARRANTIES:</strong>
                      Information and documents provided on this Site are provided without any warranty of any kind, either express or implied, including without limitation, warranties or merchantability, fitness for a particular purpose and non-infringement. Redbridge does not make any warranties or representations as to the accuracy of completeness of any information on this Site. Redbridge, from time to time, may add, change or delete information and documents on this Site without notice. Redbridge assumes no responsibility or liability for errors and omissions on this Site. Users access and use this Site at their own risk.
                    </p>
                    <p>
                      <strong>LIIMITATION OF LIABILITY:</strong>
                      Under no circumstances shall Redbridge be liable for any damages suffered by a User, including any incidental, special or consequential damages, that result from access, use or inability to use this Site, or due to any breach of security associated with the transmission of information through the internet, even if Redbridge was advised of the possibility of such damages.
                    </p>
                    <p>
                      <strong>PRIVACY:</strong>
                      Please refer to Redbridge’s Privacy Statement.
                    </p>
                    <p>
                      <strong>SECURITY:</strong>
                      The security of information transmitted through the internet cannot guarantee. Redbridge is not responsible for any interception or interruption of any communications through the internet or for changes to or losses of data. User is responsible for the security of any passwords, user id or other forms of authentication.
                    </p>
                    <p>
                      <strong>TRANSMISSION OF PERSONAL DATA</strong>
                      User acknowledges and agrees that by providing Redbridge with any personal information through this Site, User is consenting to the transmission of such information across the international borders.
                    </p>
                    <p>
                      <strong>ACCESS TO PASSWORD PROTECTED AREAS:</strong>
                      Access to and uses of password protected areas on this Site are restricted to authorized users only. Unauthorized access to such areas is prohibited.
                    </p>
                  </div>
                </div>
    
                
                <div class="row">
                  <div class="col-12 text-center">
                    <strong>PRIVACY STATEMENT</strong>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <p>
                      <strong>REDBRIDGE TRAVEL ASSIST, S.A.</strong>
                      respects and makes every commercially reasonable effort to protect your (User) privacy. The following principles govern our information and privacy practices on this web-site (“Site”).
                    </p>
                    <p>
                      <strong>USE OF INFORMATION.</strong>
                      Non-personal information may be used to tract the number of visitors to this Site. This information is strictly for international use and is not shared with third parties. Personally identifiable information such as name, address and identification numbers is collected only when voluntary provided by the User and only for the identified purposes. We will not disclose your personal information without your permission except for the purpose of fulfilling your request for information, products or services offered on this Site. We will not sell your information without your consent.
                    </p>
                    <p>
                      <strong>LEGAL REQUIREMENT.</strong>
                      We may need to disclose personally identifiable information when required by law, such as when necessary to comply with a government mandate, judicial proceeding, court order or other legal process.
                    </p>
                    <p>
                      <strong>OTHER WEBSITES.</strong>
                      This Site may contain links to other web sites with different privacy statements and practices. We are not liable or responsible for the privacy statements of any other web site.
                    </p>
                    <p>
                      <strong>CONFIDENTIALITY.</strong>
                      We make every commercially reasonable effort to protect the personal information of our Users from loss or unauthorized use. We restrict access to your personal information to our employees and authorized representatives and others who need to know this information, products and services you have requested. We maintain physical, electronic and procedural safeguards to protect confidential information.
                    </p>
                    <p>
                      <strong>MODIFICATIONS.</strong>
                      This Privacy Statement is subject to change without notice; but any changes will be posted on this page of our Site.
                    </p>
                  </div>
                </div>
    
              </div>
            </p-accordionTab>
          </p-accordion>

          <div class="col-12">
            <div class="form-group">
              <div class="p-4">
                <div class="d-flex">
                  <p-checkbox [(ngModel)]="checked" [binary]="true" class="check-style" inputId="binary"></p-checkbox>
                  <span class="pl-1">ACEPTAR</span>                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>      
    </div>
    <div class="col-12 d-flex justify-content-center pt-3">
      <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
        <div class="row d-flex justify-content-end pb-5">
          <div class="col-12 d-flex justify-content-between">
            <button (click)="prevStep()"  class="btn btn-primary back-btn-steps py-3">&lt; Paso anterior</button>
            <button (click)="nextStep()" [disabled]="checked!=true" class="btn btn-primary continue-btn-steps-footer py-3 px-3">Continuar Compra</button>
          </div>
        </div>
      </div>
    </div>
  </div>   -->
</div>


<div class="modal fade" id="sendQuoteByEmailModal" tabindex="-1" aria-labelledby="sendQuoteByEmailModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Enviar cotización por email</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div *ngIf="!emailSendingStatus || emailSendingStatus == 0">
          <div class="row" >
            <p>
              <strong>Destinatario principal:</strong> {{quoteService.quoteModel?.applicantEmail}}
            </p>
          </div>
          <div class="row" >
            <p>
              Puede ingresar varios correos electrónicos separados por coma (,) o punto y coma (;) 
            </p>
          </div>
          <form [formGroup]="sendQuoteByEmailForm">
            <div class="form-group">
              <label for="optionalRecipients" class="label-form-style">Emails</label>
              <input type="text" class="form-control input-form-full-space" formControlName="optionalRecipients" id="optionalRecipients">
            </div>
          </form>
        </div>

        <div class="row" *ngIf="emailSendingStatus == 1">
          <div class="col-12 text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>

        <div class="row" *ngIf="emailSendingStatus == 2">
          <div class="col-12">
            <div class="alert alert-success" role="alert">
              <strong>Correo enviado.</strong> Gracias por confiar en nosotros.
            </div>
          </div>
        </div>

        <div class="row" *ngIf="emailSendingStatus == 3">
          <div class="col-12">
            <div class="alert alert-danger" role="alert">
              <strong>Correo no enviado.</strong> Por favor, intente nuevamente más tarde.
            </div>
          </div>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
        <button type="button" [disabled]="canContinue!=true" class="btn btn-primary" (click)="sendEmail()">Enviar</button>
      </div>
    </div>
  </div>
</div>